import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { makeAccessApi } from 'services/accessService'

const rows = (res) => res?.data?.data || []

export const useAccessData = (scopeType, scopeId) => {
  const api = useMemo(() => makeAccessApi(scopeType, scopeId), [scopeType, scopeId])
  const [state, setState] = useState({ users: [], invitations: [], requests: [], revoked: [], domainGrants: [], loading: true, error: null, usersLoaded: false })
  const requestRef = useRef(0)

  const refetch = useCallback(async () => {
    const requestId = ++requestRef.current
    setState((s) => ({ ...s, loading: true, error: null }))
    const empty = { data: { data: [] } }
    const safe = (p) => Promise.resolve(p).catch(() => empty)
    let usersLoaded = true
    try {
      const [users, invitations, revoked, requests, domainGrants] = await Promise.all([
        Promise.resolve(api.listUsers()).catch(() => { usersLoaded = false; return empty }),
        safe(api.listInvitations()),
        safe(api.listRevoked()),
        api.supportsRequests ? safe(api.listRequests()) : Promise.resolve(empty),
        api.supportsDomainGrants ? safe(api.listDomainGrants()) : Promise.resolve(empty),
      ])
      if (requestId !== requestRef.current) return
      setState({ users: rows(users), invitations: rows(invitations), revoked: rows(revoked), requests: rows(requests), domainGrants: rows(domainGrants), loading: false, error: null, usersLoaded })
    } catch (error) {
      if (requestId !== requestRef.current) return
      setState((s) => ({ ...s, loading: false, error, usersLoaded: false }))
    }
  }, [api])

  useEffect(() => { if (scopeId) refetch() }, [scopeId, refetch])

  return { ...state, refetch, api }
}
